/* ================================================================
   CHARLES & MARIE – cm-product.js
   Standard: cm-product-standard v1.0
   FAQ Accordion – theme-agnostisch

   Upload in jedem Shop unter:
   Shopify Admin → Themes → Edit Code → assets/cm-product.js
   Dann in layout/theme.liquid vor </body> einbinden:
   {{ 'cm-product.js' | asset_url | script_tag }}
================================================================ */

(function () {
  'use strict';

  function initCmFaq() {
    var items = document.querySelectorAll('.cm-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.cm-faq-q');
      var answer = item.querySelector('.cm-faq-a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Optional: alle anderen schließen (Accordion-Verhalten)
        // Auskommentieren wenn mehrere gleichzeitig offen sein sollen:
        // document.querySelectorAll('.cm-faq-item.is-open').forEach(function(el) {
        //   el.classList.remove('is-open');
        //   el.querySelector('.cm-faq-q').setAttribute('aria-expanded', 'false');
        //   el.querySelector('.cm-faq-a').hidden = true;
        // });

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  // DOM ready – kompatibel mit allen Themes inkl. defer-loaded Sections
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCmFaq);
  } else {
    initCmFaq();
  }

  // Shopify Section rendering (für Theme Editor Live-Preview)
  document.addEventListener('shopify:section:load', initCmFaq);

})();